import { render } from "./IndexTransactionPage.vue?vue&type=template&id=c7924ffc"
import script from "./IndexTransactionPage.vue?vue&type=script&lang=js"
export * from "./IndexTransactionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__